import common from './common'
import year2016 from './2016/messages'
import year2017 from './2017/messages'
import year2018 from './2018/messages'
import year2019 from './2019/messages'

export default {
  common,
  year2016,
  year2017,
  year2018,
  year2019
}



// WEBPACK FOOTER //
// ./i18n/messages.js